import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { queryKeys, unwrap, type components } from '@geefamily/api';
import { api } from '@/app/api';
import { useAuth } from '@/features/auth/use-auth';
export type Milestone = components['schemas']['MilestoneDefinitionResponse'];
export type MilestoneProgress = components['schemas']['MilestoneProgressResponse'];
export type MilestoneRoadmap = components['schemas']['MilestoneRoadmapResponse'];
export type MilestoneReceipt = components['schemas']['ClaimMilestoneResponse'];
export type ClaimRequest = components['schemas']['ClaimMilestoneRequest'];
const keys = queryKeys.module('market');
export function useMilestones() {
  return useQuery({
    queryKey: keys.entity('milestones').lists(),
    queryFn: () => unwrap<Milestone[]>(api.GET('/api/v1/market/milestones', {})),
    staleTime: 15_000,
  });
}
export function useMyMilestones() {
  const { user, isAuthenticated } = useAuth();
  return useQuery({
    queryKey: [...keys.entity('me').detail(user?.id ?? ''), 'milestones'],
    queryFn: () => unwrap<MilestoneRoadmap>(api.GET('/api/v1/market/me/milestones', {})),
    enabled: isAuthenticated && Boolean(user),
    staleTime: 0,
  });
}
export function useClaimMilestone(onCommitted: (receipt: MilestoneReceipt) => void) {
  const client = useQueryClient();
  return useMutation({
    mutationFn: ({ id, body }: { id: string; body: ClaimRequest }) =>
      unwrap<MilestoneReceipt>(
        api.POST('/api/v1/market/milestones/{id}/claim', { params: { path: { id } }, body }),
      ),
    retry: false,
    onSuccess: onCommitted,
    onSettled: () => client.invalidateQueries({ queryKey: keys.all }),
  });
}
